import { registerValidator } from '../validatorRegistry';

registerValidator({
  key: 'transparency',
  runsOn: ['upload'],
  async validate(ctx) {
    const img = ctx.imageElement!;

    // SVGs are vector — skip pixel sampling
    if (ctx.file?.type === 'image/svg+xml') {
      return { key: 'transparency', status: 'pass', blocker: false, title: 'Vector format', message: 'SVG — transparency handled by vector data.' };
    }

    const canvas = document.createElement('canvas');
    const maxSample = 1024;
    const scale = Math.min(1, maxSample / Math.max(img.naturalWidth, img.naturalHeight));
    canvas.width = Math.round(img.naturalWidth * scale);
    canvas.height = Math.round(img.naturalHeight * scale);

    const offCtx = canvas.getContext('2d')!;
    offCtx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const data = offCtx.getImageData(0, 0, canvas.width, canvas.height).data;

    let hasTransparency = false;
    for (let i = 3; i < data.length; i += 16) {
      if (data[i] < 250) { hasTransparency = true; break; }
    }

    if (!hasTransparency) {
      return {
        key: 'transparency', status: 'warning', blocker: false,
        title: 'No transparent background',
        message: "This image doesn't appear to have a transparent background. It may cover the garment behind it. This is fine if intentional.",
        suggestion: 'Export as PNG-24 with transparency if you want the background removed.',
      };
    }
    return { key: 'transparency', status: 'pass', blocker: false, title: 'Transparent background', message: 'Image has transparency.' };
  },
});
